export default __webpack_public_path__ + "static/media/300.5ef909a9.png";